import clonedeep from 'lodash.clonedeep'
import moment from '@/moment-gp'
import { walkDelete } from '@/generic_api/lib/generic_store/vuefire/utils'

// Syntax getter:
//
// getter: ( $models, $registry, $this ) => { ... }
// getter: ( $models, { state, getters, dispatch, commit }) => { ... }
//
//  Also this = store
//
// Vorschlag:
// getter: ({ $models, store =regular store), $registry, $this }) => { ... }

export default {

  // ---------------------------------------------------------------------------
  /* *NEW* Sub path based getter */
  example: ( $models, $registry, $store ) => {
    // Use like: $models.commitment.with({ goalId: '123' }).getters.example
    console.log( $store.definedProps )
    console.log( $store.path )
  },

  // ---------------------------------------------------------------------------
  commitment_settings_current_user: ( $models, $registry, $store ) => {

    if ( !( 'goalId' in $store.definedProps ) ) {
      throw new Error('Please define goalId in "with".')
    }

    let goalId = $store.definedProps[ 'goalId' ]

    let commitment_settings_grouped_by_commitment_id = {}

    function map_commitment_settings_to_commitment_buckets( commitmentSettings) {

      commitmentSettings.itemsAsArray().forEach((commitmentSettings) => {
        Object.keys(commitmentSettings.$state).forEach(commitmentItem => {
          if ( !( commitmentItem in commitment_settings_grouped_by_commitment_id ) ) {
            commitment_settings_grouped_by_commitment_id[ commitmentItem ] = []
          }
          commitment_settings_grouped_by_commitment_id[ commitmentItem ].push({
            dateTimestamp: commitmentSettings.$id,
            committedTimeDaily: commitmentSettings.$state[commitmentItem].committedTimeDaily
          })
        })
        //let commitmentId = commitmentSettings.$state
      })
    }

    //let commitment_settings_grouped_by_commitment_id = {}
    /* commitmentSettings have not been loaded. */
    let dateTimestampToday = moment().utc().startOf('day').unix()
    let commitmentSettings = $models.commitmentDailySettings
      .with({ goalId })
      .subscribeQuery({ startAt: dateTimestampToday.toString() })
    // TODO: This won't work! Must be YYMMDD string!!!

    map_commitment_settings_to_commitment_buckets(commitmentSettings)
    //console.log('commitment_settings_grouped_by_commitment_id:', commitment_settings_grouped_by_commitment_id)
    return commitment_settings_grouped_by_commitment_id
  },

  // ---------------------------------------------------------------------------
  commitment_list_all_optimizer: ( $models, $registry, $store ) => {

    const IRRELEVANT_FIELD_LIST = [
      'allowToEdit',
      'createdAt',
      'createdBy',
      'deleted',
      'graphicalRepresentation',
      'parentGoalId',
      'sortidx',
      'picture',
      'showFinished',
      'meta',
      'user.graphicalRepresentation',
      'user.showFinished',
      'user.userLeftGroup',
    ]

    // Same thing: $store.getters === $models.commitment.getters

    let commitment_list = clonedeep( $store.getters.commitment_list_all );

    commitment_list.forEach(commitment => {
      IRRELEVANT_FIELD_LIST.forEach(path => {
        // delete commitment[ field ];
        walkDelete( commitment, path )
      });
    });

    return commitment_list;
  },

  // ---------------------------------------------------------------------------
  commitment_list_all_including_other_user: ( $models, $registry ) => {
    // TODO
  },

  // ---------------------------------------------------------------------------
  /*
  return all commitments, including commitments of other users!
  (Used as optimizer input)
  */
  commitment_list_all: ( $models, $registry, $store ) => {

    // TODO: Use this.$models.commitment.with({ goalId: this.goalId }).getNodeFull( this.commitmentId )

    // console.log('[GETTER:commitment] commitment_list_all');

    if ( !$registry.state.res.goal ) {
      console.log("... still loading 1 ...");
      return [];
    }

    if ( !$registry.state.ready.goals ) {
      console.log(".. still loading A ...")
    }

    if ( !$registry.state.ready.commitments ) {
      console.log(".. still loading B ...")
    }

    // TODO: Try to return Promise, with:
    // var seq_list = this.$models.sequence.subscribeList();
    // seq_list.$promise.then((x) => console.log('GOT RESULT', x, seq_list));

    let loaded_goal_id_list = Object.keys( $registry.state.res.goal );
    // console.log("[GETTER:commitment] loaded_goal_id_list", loaded_goal_id_list);

    let commitment_result_list = [];
    loaded_goal_id_list.every(goal_id => {

      let goal_meta = $registry.state.res.goal[ goal_id ].meta;

      /* Check if goal exists and if we have access rights */
      if ( !goal_meta || goal_meta[ '.exists' ] === false || goal_meta[ '.noaccess' ] === true ) {
        console.log("Goal: No access or does not exist", goal_id)
        return false;
      }

      let commitment_meta_list = $models.commitmentMeta.with({ goalId: goal_id }).getList()
      // TODO: Test if ready

      // console.log("[GETTER:commitment] commitment_meta_list", goal_id, commitment_meta_list);

      if ( !commitment_meta_list.$readySome ) {
        console.log("... still loading 2 ...");
        // return false; /* Won't work! */
        return true;
      }

      let commitment_meta_list_sorted = commitment_meta_list.asArraySorted();

      // let commitment_list = $models.commitment
      //                  .with({ goalId: goal_id })
      //                  .subscribeList(/* id list */);

      commitment_meta_list_sorted.items.forEach( commitment_meta => {

        // console.log(">> commitmentId", commitment_meta.$id);

        if ( commitment_meta.assignedUserId !== $models.user.defaultUserId ) {
          /* Skip others users commitments */
          return
        }

        // TODO: Test if ready, return $ready here too??

        // let commitment = $registry.state.res.goal[ goal_id ].commitment
        let commitment = $models.commitment
                         .with({ goalId: goal_id })
                         .getNode( commitment_meta.$id )

        // TODO: It is possible, that the user does not have a commitment setting

        let commmitment_user_settings = null;
        let user_data = $registry.state.res.user[ $models.user.defaultUserId ]
        let commitment_settings_list = user_data.commitment_settings || {}

        if ( commitment_meta.$id in commitment_settings_list ) {
          commmitment_user_settings =
            $models.userCommitmentSettings.getNode( commitment_meta.$id );
        }

        if ( !commitment
          || !commitment.$ready
          || commitment_meta.deleted ) {
          return
        } else {
          // commitment = commitment.clone().$state

          // This does not create moment objects!
          commitment = clonedeep( commitment.$state );
          commitment.meta = clonedeep( commitment_meta.$state );
          if (commmitment_user_settings) {
            commitment.user = clonedeep( commmitment_user_settings.$state );
          } else {
            commitment.user = '' // ??
          }

          // Convert moment objects!
          commitment.startDate = moment.fromRealtimeDB( commitment.startDate );
          commitment.endDate = moment.fromRealtimeDB( commitment.endDate );
        }

        // console.log("commitment ready:", commitment);

        //console.log('commitment_meta sortidx',  loaded_goal_id_list)
        /*let commitment_user_settings_list = $models.userCommitmentSettings
          .with({ timeslotCollectionId: tsc_id })
          .getList();

        let array = commitment_user_settings_list.itemsAsArray();*/

        let rank = parseInt( ( commitment.user.prioidx  || 0 ) / 100 );

        commitment_result_list.push({
          ...commitment,
          commitmentId: commitment_meta.$id,
          goalId: goal_id,
          active: commitment_meta.active,
          rank: rank
        });

      });
      return true;
    });
    return commitment_result_list;
  },

  // get_effort_list() { },
  // get_backlog_list() { },
}
